import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from 'libs/portal/src/layout/layout.component';
import { AuthGuardService } from 'libs/portal/src/services/auth-guard/auth-guard.service';
import { MikrotikDashboardPageComponent } from './pages/mikrotik-dashboard/mikrotik-dashboard.page';

const routes: Routes = [
  {
    path: 'Dashboard',
    component: LayoutComponent,
    data: { breadcrumb: 'Dashboard' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: MikrotikDashboardPageComponent,
      },
    ],
  },
  {
    path: 'Devices',
    data: { breadcrumb: 'Devices' },
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./pages/mikrotik-devices/mikrotik-devices.module').then((m) => m.MikrotikDevicesPageModule),
  },
  {
    path: 'Map',
    data: { breadcrumb: 'Map' },
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./pages/mikrotik-map/mikrotik-map.module').then((m) => m.MikrotikMapPageModule),
  },

  //   {
  //     path: "Devices",
  //     canActivate: [AuthGuardService],
  //     component: LayoutComponent,
  //     loadChildren: () =>
  //       import("./pages/devices/devices.module").then((m) => m.DevicesModule),
  //   },
  //   {
  //     path: "Alerts",
  //     canActivate: [AuthGuardService],
  //     component: LayoutComponent,
  //     loadChildren: () =>
  //       import("./pages/alerts/alerts.module").then((m) => m.AlertsModule),
  //   },
  //   {
  //     path: "AlertConfiguration",
  //     canActivate: [AuthGuardService],
  //     component: LayoutComponent,
  //     loadChildren: () =>
  //       import("./pages/alert-configuration/alert-configuration.module").then(
  //         (m) => m.AlertConfigurationModule
  //       ),
  //   },
  //   {
  //     path: "Reports",
  //     canActivate: [AuthGuardService],
  //     component: LayoutComponent,
  //     loadChildren: () =>
  //       import("./pages/reports/reports.module").then((m) => m.ReportsModule),
  //   },
  //   {
  //     path: "Report/:id",
  //     canActivate: [AuthGuardService],
  //     component: LayoutComponent,
  //     loadChildren: () =>
  //       import("./pages/report-details/report-details.module").then(
  //         (m) => m.ReportDetailsModule
  //       ),
  //   },
  //   {
  //     path: "Map",
  //     canActivate: [AuthGuardService],
  //     component: LayoutComponent,
  //     loadChildren: () =>
  //       import("./pages/map/map.module").then((m) => m.MapModule),
  //   },
  //   {
  //     path: "Device/:id",
  //     canActivate: [AuthGuardService],
  //     component: LayoutComponent,
  //     loadChildren: () =>
  //       import("./pages/device-details/device-details.module").then(
  //         (m) => m.DeviceDetailsModule
  //       ),
  //   },
  //   {
  //     path: "DeviceRingfenceLogs",
  //     canActivate: [AuthGuardService],
  //     component: LayoutComponent,
  //     loadChildren: () =>
  //       import("./pages/device-logs/device-logs.module").then(
  //         (m) => m.DeviceLogsModule
  //       ),
  //   },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AuthGuardService],
})
export class MikrotikRoutingModule {}
